<template>
  <div
    class="fixed top-0 left-0 z-50  bg-gray bg-opacity-80 h-screen w-screen"
    :class="{ hidden: !showIf, block: showIf }"
  >
    <div
      class="fixed w-full max-h-screen lg:w-1/2 z-50  top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/3  rounded-md"
      :class="{'bg-white border border-semigray' : !isTransparent, 'lg:w-1/2':half}"
    >
      <div
        v-if="title"
        class="w-full p-5  border-b border-gray-light border-solid"
      >
        {{ title }}
      </div>
      <div class="w-full p-5">
        <slot>Modal body</slot>
      </div>
      <div
        v-if="hasButtons"
        class="w-full p-5 border-t  border-gray-light border-solid"
      >
        <div class="w-full lg:w-1/2 flex gap-3 flex-row justify-center justify-items-center mx-auto">
          <slot name="buttons">
            <button
              v-if="hasAccept"
              class="btn btn-red w-1/2"
              @click.prevent="$emit('onAccept')"
            >
              {{ acceptText }}
            </button>
            <button
              class="btn btn-yellow w-1/2"
              @click.prevent="$emit('onClose')"
            >
              Mégse
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showIf: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
    },
    hasAccept: {
      type: Boolean,
      default: true
    },
     hasButtons: {
      type: Boolean,
      default: true
    },
    acceptText: {
      type: String,
      default: 'Ok'
    },
    isTransparent:{
       type: Boolean,
      default: false
    },
    half:{
     type: Boolean,
      default: false
    }
  }
}
</script>